<div *ngIf="loading" class="loading-indicator">Loading...</div>
<div *ngIf="!loading">
  <mat-sidenav-container>
    <mat-sidenav #sidenav>
      <app-menu (itemChosen)="sidenav.close()"></app-menu>
    </mat-sidenav>

    <div #scrollContainer class="scroll-container">
      <app-toolbar (toggleMenu)="sidenav.toggle()"></app-toolbar>
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-container>
</div>
